"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChannelOptionButtonsPopup = exports.ChannelBtnType = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ButtonGroup = require("../ButtonGroup");
var _Popup = require("../Popup");
var _email = _interopRequireDefault(require("../../assets/images/email.svg"));
var _phonecall = _interopRequireDefault(require("../../assets/images/phonecall.svg"));
var _tools = require("../../utils/tools");
var _LocaleProvider = require("../LocaleProvider");
var _getPrefixCls = require("../../utils/getPrefixCls");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ChannelBtnType;
exports.ChannelBtnType = ChannelBtnType;
(function (ChannelBtnType) {
  ChannelBtnType["BtnLive"] = "btn_live";
  ChannelBtnType["BtnSubmitWebform"] = "btn_submit_webform";
  ChannelBtnType["BtnGeneralCall"] = "btn_general_call";
  ChannelBtnType["BtnVirtualCall"] = "btn_virtual_call";
})(ChannelBtnType || (exports.ChannelBtnType = ChannelBtnType = {}));
function getBtnIcon(type) {
  if (type === ChannelBtnType.BtnSubmitWebform) {
    return _email.default;
  }
  if (type === ChannelBtnType.BtnGeneralCall) {
    return _phonecall.default;
  }
  return undefined;
}
var ChannelOptionButtonsPopup = function ChannelOptionButtonsPopup(props) {
  var active = props.active,
    onClose = props.onClose,
    buttons = props.buttons;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  return /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    active: active,
    onClose: onClose,
    showCloseButton: true,
    closeButtonText: trans('channel_selection_cancel_btn')
  }, /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, {
    layout: "vertical",
    buttons: buttons.map(function (v) {
      var _v$extraParam, _v$extraParam2;
      return _objectSpread(_objectSpread({}, v), {}, {
        className: "".concat((0, _getPrefixCls.getPrefixCls)('channel-options-card'), "-popup-button"),
        children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, getBtnIcon(v.buttonType) != null && /*#__PURE__*/_react.default.createElement("img", {
          src: getBtnIcon(v.buttonType)
        }), /*#__PURE__*/_react.default.createElement("span", null, v.text)), ((_v$extraParam = v.extraParam) === null || _v$extraParam === void 0 ? void 0 : _v$extraParam.day) != null ? /*#__PURE__*/_react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: "(".concat((0, _tools.replaceParams)(v.extraParam.desc, {
              day: "<span>".concat(v.extraParam.day, "</span>")
            }), ")")
          }
        }) : /*#__PURE__*/_react.default.createElement("div", null, "(", (_v$extraParam2 = v.extraParam) === null || _v$extraParam2 === void 0 ? void 0 : _v$extraParam2.desc, ")")),
        onClick: function onClick() {
          var _v$onClick;
          (_v$onClick = v.onClick) === null || _v$onClick === void 0 ? void 0 : _v$onClick.call(v);
          onClose();
        }
      });
    })
  }));
};
exports.ChannelOptionButtonsPopup = ChannelOptionButtonsPopup;